import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { selectUser } from 'selectors';
import styled from 'styled-components';
import { Container, Image, responsive } from 'styled-minimal';

import { GoogleApiContext } from 'modules/GoogleApiContext';
import { useAppSelector } from 'modules/hooks';
import { appColor, headerHeight, spacer } from 'modules/theme';

// import { coaches } from 'config';

import { logOut, userExport } from 'actions';

// import Icon from 'components/Icon';
// import Logo from 'components/Logo';

import Modal from './Modal';

const HeaderWrapper = styled.header`
  background-color: rgb(238, 238, 238);
  color: black;
  padding-top: 20px;
  border-radius: 20px 0 0 20px;
  // height: ${headerHeight}px;
  // left: 0;
  // position: fixed;
  // right: 0;
  // top: 0;
  // z-index: 200;

  // &:before {
  //   background-color: ${appColor};
  //   bottom: 0;
  //   content: '';
  //   height: 0.2rem;
  //   left: 0;
  //   position: absolute;
  //   right: 0;
  // }
`;

const HeaderContainer = styled(Container)`
  align-items: flex-start;
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  justify-content: center;
  padding: 0;
  // padding-bottom: ${spacer(2)};
  // padding-top: ${spacer(2)};
`;

const Actions = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-start;
  flex-direction: column;
  width: 200px;
`;

const Action = styled.button`
  align-items: center;
  // color: rgb(232, 119, 34);
  color: black;
  display: flex;
  font-size: 1.5rem;
  padding: ${spacer(3)};
  gap: 16px;
  text-align: left;
  width: 100%;

  // ${responsive({ md: { fontSize: '1.6rem' } })}; /* stylelint-disable-line */

  &:hover {
    background-color: white;
  }
  span {
    display: inline-block;
    margin-right: 0.4rem;
    text-transform: none;
  }

  .icon {
    border-radius: 50px;
    min-width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgb(232, 119, 34);
    margin-right: 8px;
    border: 3px solid transparent;
    color: white;
  }

  // &:hover .icon {
  //   background-color: #999;
  // }

  // &:active .icon {
  //   color: rgb(232, 119, 34);
  //   background-color: white;
  // }
`;

// const Title = styled.span`
//   font-size: 1.6rem;
//   font-weight: 700;
//   display: none;
//   ${responsive({ md: { display: 'block' } })};
//   // position: absolute;
//   // left: calc(50% - 144px);
// `;

export default function Header() {
  const user = useAppSelector(selectUser);
  const { coach, ikigai, messages, name, questions } = user;
  const question = questions[coach];
  const dispatch = useDispatch();
  const { loaded, tokenClient } = useContext(GoogleApiContext);
  const [saveAction, setSaveAction] = useState<0 | 1>(0);

  const handleClickLogout = () => {
    dispatch(logOut());
  };

  const withGoogleApi = (callback: () => void) => {
    if (tokenClient == null) {
      return;
    }

    (tokenClient as any).callback = async (resp: any) => {
      if (resp.error !== undefined) {
        throw resp;
      }

      callback();
    };

    if ((window as any).gapi.client.getToken() === null) {
      // Prompt the user to select a Google Account and ask for consent to share their data
      // when establishing a new session.
      (tokenClient as any).requestAccessToken({ prompt: 'consent' });
    } else {
      // Skip display of account chooser and consent dialog for an existing session.
      (tokenClient as any).requestAccessToken({ prompt: '' });
    }
  };

  const handleSave = (action: 0 | 1) => {
    if (action === 1) {
      dispatch(userExport());
    }

    setSaveAction(action);
    withGoogleApi(() => {
      setShowModal(true);
    });
  };

  const [showModal, setShowModal] = useState(false);
  const [filename, setFilename] = useState('');

  const handleFilenameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFilename(event.target.value);
  };

  const handleSubmit = async () => {
    await (saveAction === 0 ? handleSaveToDoc() : handleExportIkigai());
    handleCancel();
  };

  const handleSaveToDoc = async () => {
    const createResponse = await (window as any).gapi.client.docs.documents.create({
      title: filename,
    });

    console.log(createResponse.result);

    // now that we created the doc, let's add content using the
    // documentId returned from the create call.
    const documentId = createResponse?.result?.documentId; // nullish coalescing operator

    if (documentId) {
      let text = '';
      // const ranges: number[][] = [];

      messages[coach].forEach((value, index) => {
        if (index < 2) {
          return;
        }

        const content = value.content.replaceAll('\r', '\r\n');

        if (value.role === 'assistant') {
          // ranges.push([text.length + 1, text.length + 8]);
          text += `ChatGPT4\r\n${content}\r\n\r\n`;
        } else if (value.role === 'user') {
          // ranges.push([text.length + 1, text.length + 12 + value.content.length]);
          text += `User Input: ${content}\r\n\r\n`;
        }
      });
      text += `ChatGPT4\r\n${question}`;
      const updateResponse = await (window as any).gapi.client.docs.documents.batchUpdate({
        documentId,
        requests: [
          {
            insertText: {
              endOfSegmentLocation: {},
              text,
            },
          },
        ],
      });

      console.log(updateResponse.result);
      window.open(`https://docs.google.com/document/d/${documentId}/edit`);
    }

    setShowModal(false);
  };

  const handleExportIkigai = async () => {
    const createResponse = await (window as any).gapi.client.drive.files.copy({
      name: filename,
      // fileId: '1hMtqnGBw7TDXQ4P-JYebKK6CMPo-ZLQj_Eh8ooA9l5c',
      fileId: '1bNbccH96dzlx5FZTaCminw_BMnjz9hJUf9hkFkehNM8',
    });
    const id = createResponse?.result?.id; // nullish coalescing operator
    const getResponse = await (window as any).gapi.client.slides.presentations.get({
      presentationId: id,
    });
    const presentation = getResponse.result;

    if (!presentation || !presentation.slides || presentation.slides.length === 0) {
      // eslint-disable-next-line no-alert
      alert('No slides found. Ikigai template error');

      return;
    }

    // console.log(presentation.slides[0]);
    const updateResponse = await (window as any).gapi.client.slides.presentations.batchUpdate({
      presentationId: id,
      requests: [
        {
          replaceAllText: {
            containsText: {
              text: '{{name}}',
              matchCase: true,
            },
            replaceText: name,
          },
        },
        {
          replaceAllText: {
            containsText: {
              text: '{{My Interests}}',
              matchCase: true,
            },
            replaceText: `My Interests:\r\n${(ikigai.interests || [])
              .map((item: string) => `● ${item}`)
              .join('\r\n')}`,
          },
        },
        {
          replaceAllText: {
            containsText: {
              text: '{{My Values}}',
              matchCase: true,
            },
            replaceText: `My Values:\r\n${(ikigai.values || [])
              .map((item: string) => `● ${item}`)
              .join('\r\n')}`,
          },
        },
        {
          replaceAllText: {
            containsText: {
              text: '{{My Skills}}',
              matchCase: true,
            },
            replaceText: `My Skills:\r\n${(ikigai.skills || [])
              .map((item: string) => `● ${item}`)
              .join('\r\n')}`,
          },
        },
        {
          replaceAllText: {
            containsText: {
              text: '{{My Worth}}',
              matchCase: true,
            },
            replaceText: `My Worth:\r\n${(ikigai.worth || [])
              .map((item: string) => `● ${item}`)
              .join('\r\n')}`,
          },
        },
        {
          replaceAllText: {
            containsText: {
              text: '{{Career Interest 01}}',
              matchCase: true,
            },
            replaceText: `Career Interest 01:   ${ikigai.career_interest_1 || ''}\r\n\r\n${ikigai.career_interest_1_desc || ''}`,
          },
        },
        {
          replaceAllText: {
            containsText: {
              text: '{{Career Interest 02}}',
              matchCase: true,
            },
            replaceText: `Career Interest 02:   ${ikigai.career_interest_2 || ''}\r\n\r\n${ikigai.career_interest_2_desc || ''}`,
          },
        },
      ],
    });

    console.log(updateResponse.result);

    /* const getOptions = {
      spreadsheetId: '18x2cMf9Km-yNWXKH7-52MAttpuHXJeIcypAdRAmDhSs',
      range: 'Sheet1',
    };

    const gotData = await (window as any).gapi.client.sheets.spreadsheets.values.get(getOptions);
    const template = gotData.result.values[1];

    const newRow = [];

    for (const row of template) {
      switch (row) {
        case '[auto]':
          newRow.push(gotData.result.values.length - 1);
          break;
        case '[timestamp]':
          newRow.push(new Date().toLocaleString('en-US', { timeZone: 'America/Chicago' }));
          break;
        case '{{role}}':
          newRow.push(coach ? 'student' : 'mentor');
          break;
        case '{{name}}':
          newRow.push(name);
          break;
        case '{{interests}}':
          newRow.push(ikigai.interests.join(', '));
          break;
        case '{{values}}':
          newRow.push(ikigai.values.join(', '));
          break;
        case '{{worth}}':
          newRow.push(ikigai.worth.join(', '));
          break;
        case '{{career_01}}':
          newRow.push(ikigai.career_interest_1);
          break;
        case '{{career_02}}':
          newRow.push(ikigai.career_interest_2);
          break;
      }
    }

    // Add the new row
    const updateOptions = {
      spreadsheetId: '18x2cMf9Km-yNWXKH7-52MAttpuHXJeIcypAdRAmDhSs',
      range: 'Sheet1',
      valueInputOption: 'USER_ENTERED',
      resource: { values: [newRow] },
    };
    const result = await (window as any).gapi.client.sheets.spreadsheets.values.append(
      updateOptions,
    );
    console.log(result); */

    window.open(`https://docs.google.com/presentation/d/${id}/edit`);
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  return (
    <HeaderWrapper data-testid="Header">
      <HeaderContainer>
        {/* <Actions>
          <Logo />
          <Title>{coaches[coach].name}</Title>
        </Actions> */}
        <Actions>
          {loaded && question && (
            <>
              <Action
                onClick={() => {
                  handleSave(0);
                }}
              >
                <Image
                  style={{ marginLeft: '4px', marginRight: '4px' }}
                  width={24}
                  src={`${process.env.PUBLIC_URL}/media/images/docs.png`}
                  alt="save to google doc"
                />
                <span>Save Transcript to Google Docs</span>
              </Action>
              <Action
                onClick={() => {
                  handleSave(1);
                }}
              >
                <Image
                  width={32}
                  src={`${process.env.PUBLIC_URL}/media/images/print.png`}
                  alt="save to google slide"
                />
                <span>Export to Google Slides</span>
              </Action>
            </>
          )}
          <Action onClick={handleClickLogout}>
            <Image
              width={32}
              src={`${process.env.PUBLIC_URL}/media/images/start.png`}
              alt="save to google slide"
            />
            <span>Start Over</span>
          </Action>
        </Actions>
        {/* <Modal isOpen={open} onClose={() => setOpen(false)} /> */}
        {showModal && (
          <Modal
            filename={filename}
            onCancel={handleCancel}
            onFilenameChange={handleFilenameChange}
            onSubmit={handleSubmit}
            title={saveAction ? 'Export Ikigai to Google Slide' : 'Save to Google Docs'}
          />
        )}
      </HeaderContainer>
    </HeaderWrapper>
  );
}
